import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import DataTable from '../../../components/ui/DataTable';
import { fmt, hasNum, signed } from '../config';
import { unitValue } from './UnitTrendPanel';

// Analiz §14 E11 alt alan — bütün birimler (DataTable; tek kaydırma: yalnız tablo satırları kayar). Sütunlar dönem başına
// değer + n (gizli hücre "Gizli"), değişim, dahil/hariç kişi. Veri birimler ucundan bir kez gelir (en çok 500 birim; fazlası
// için uyarı) — istemci tarafı sayfalama.
export default function TrendUnitsTab({ panel, periods, height }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const units = panel.data?.units || [];
  const data = useMemo(() => units.map((u) => {
    const row = {
      id: u.key || 'none',
      unit: u.label || t('performance.trends.unassigned'),
      change: u.changeSuppressed ? t('performance.trends.suppressed') : (hasNum(u.change) ? signed(u.change, lang) : '-'),
      goalChange: u.changeSuppressed ? t('performance.trends.suppressed') : (hasNum(u.goalChange) ? signed(u.goalChange, lang) : '-'),
      included: u.includedN,
      excluded: u.excludedN,
    };
    u.values.forEach((v, i) => {
      row[`v${i}`] = unitValue(v, t, lang);
      row[`n${i}`] = v.suppressed ? t('performance.trends.suppressed') : (v.n ?? 0);
      row[`g${i}`] = v.suppressed ? t('performance.trends.suppressed') : (hasNum(v.goal) ? fmt(v.goal, lang) : '-');
    });
    return row;
  }), [units, t, lang]);

  const columns = useMemo(() => [
    { name: 'unit', label: t('performance.trends.col.unit'), options: { filter: false } },
    ...(periods || []).flatMap((p, i) => [
      { name: `v${i}`, label: t('performance.trends.col.periodValue', { name: p.name }), options: { filter: false, sort: false } },
      { name: `g${i}`, label: t('performance.trends.col.periodGoal', { name: p.name }), options: { filter: false, sort: false } },
      { name: `n${i}`, label: t('performance.trends.col.periodN', { name: p.name }), options: { filter: false, sort: false } },
    ]),
    { name: 'change', label: t('performance.trends.col.change'), options: { filter: false, sort: false } },
    { name: 'goalChange', label: t('performance.trends.col.goalChange'), options: { filter: false, sort: false } },
    { name: 'included', label: t('performance.trends.col.included'), options: { filter: false } },
    { name: 'excluded', label: t('performance.trends.col.excluded'), options: { filter: false } },
  ], [periods, t]);

  return (
    <DataTable
      title={t('performance.trends.tab.units')}
      columns={columns}
      data={data}
      serverSide={false}
      pageSize={20}
      disableFilters
      fetching={panel.loading}
      tableBodyMaxHeight={height ? `${Math.max(200, height - 150)}px` : undefined}
    />
  );
}
